



















































import { Component, Vue } from "vue-property-decorator";
import apiService from "@/services/apiService/apiService";
import SpatialNavigation from "spatial-navigation-js";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { formPosMap, SettingsMutations } from "@/components/settings/types";
import { Action, Mutation } from "vuex-class";
import { Namespace } from "@/store/types";
import { LocaleSettingsRightSideMenu } from "@/plugins/i18n/types";
import { AlertAction, AlertState, AlertType } from "@/components/alert/types";

@Component({})
export default class PinChange extends Vue {
  @Action(AlertAction.UpdateAlert, { namespace: Namespace.Alert })
  alertReset!: (alertData: AlertState) => void;

  @Mutation(SettingsMutations.setOpenRightSideMenu, {
    namespace: Namespace.Settings
  })
  setOpenRightSideMenu!: (overlayStatus: boolean) => void;

  oldPin = "";
  newPin = "";
  newPinConfirm = "";

  formPos = 0;
  LocaleSettingsRightSideMenu = LocaleSettingsRightSideMenu;

  async changePin(): Promise<void> {
    try {
      await apiService.verifyPin({ pin_code: this.oldPin });
      await apiService.updatePin({
        old_pin_code: parseInt(this.oldPin),
        pin_code: parseInt(this.newPin),
        confirm_pin_code: parseInt(this.newPinConfirm)
      });
      this.alertReset({
        show: true,
        message: "Pin Changed",
        alertType: AlertType.Success
      });
    } catch (e) {
      switch (e.response.status) {
        case 423:
          this.alertReset({
            show: true,
            message: e.response.data.message,
            alertType: AlertType.Danger
          });
          break;
        case 422:
          this.alertReset({
            show: true,
            message: e.response.data[0].message,
            alertType: AlertType.Danger
          });
          break;
        case 500:
          this.alertReset({
            show: true,
            message: "Network Error",
            alertType: AlertType.Danger
          });
          break;
      }
    }
  }

  focusMenuItem(): void {
    switch (this.formPos) {
      case 0:
        SpatialNavigation.focus(formPosMap.oldPin);
        break;
      case 1:
        SpatialNavigation.focus(formPosMap.newPin);
        break;
      case 2:
        SpatialNavigation.focus(formPosMap.newPinConfirm);
        break;
      case 3:
        SpatialNavigation.focus(formPosMap.changePinBtn);
        break;
    }
  }

  closeMenu(): void {
    this.setOpenRightSideMenu(false);
    SpatialNavigation.resume();
  }

  handleFormActions(event: KeyboardEvent): void {
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_DOWN:
        if (this.formPos < 3) {
          this.formPos++;
          this.focusMenuItem();
        }
        break;
      case KeySet.KEY_UP:
        if (this.formPos > 0) {
          this.formPos--;
          this.focusMenuItem();
        }
        break;
      case KeySet.KEY_BACK:
        switch (this.formPos) {
          case 0:
            if (this.oldPin === "") {
              this.closeMenu();
            }
            break;
          case 1:
            if (this.newPin === "") {
              this.closeMenu();
            }
            break;
          case 2:
            if (this.newPinConfirm === "") {
              this.closeMenu();
            }
            break;
          case 3:
            this.closeMenu();
            break;
        }
        break;
    }
  }
}
